// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/project_jobs.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type {
  DenormalizedClient,
  DenormalizedClientJson,
  DenormalizedJobType,
  DenormalizedJobTypeJson,
  DenormalizedProject,
  DenormalizedProjectJson,
  DenormalizedUser,
  DenormalizedUserJson,
} from './denormalized_pb';
import { file_proto_v1_denormalized } from './denormalized_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  AuditUpdater,
  AuditUpdaterJson,
  AuditUpdaterValid,
  DateRange,
  DateRangeJson,
  Pagination,
  PaginationJson,
  PaginationValid,
  ProjectJobType,
  ProjectJobTypeJson,
  SortDirection,
  SortDirectionJson,
  UploadedFile,
  UploadedFileJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/project_jobs.proto.
 */
export const file_proto_v1_project_jobs: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_denormalized,
      file_proto_v1_extension_enum,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermit
 */
export type ProjectJobPermit =
  Message<'vmspdb.api.proto.v1.ProjectJobPermit'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 1;
     */
    type: ProjectJobPermitType;

    /**
     * @generated from field: repeated string owners = 2;
     */
    owners: string[];

    /**
     * @generated from field: string contractor = 3;
     */
    contractor: string;

    /**
     * @generated from field: string erosion_control_contractor = 5;
     */
    erosionControlContractor: string;

    /**
     * @generated from field: double cost = 6;
     */
    cost: number;

    /**
     * @generated from field: double service_fee = 7;
     */
    serviceFee: number;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermit
 */
export type ProjectJobPermitJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 1;
   */
  type?: ProjectJobPermitTypeJson;

  /**
   * @generated from field: repeated string owners = 2;
   */
  owners?: string[];

  /**
   * @generated from field: string contractor = 3;
   */
  contractor?: string;

  /**
   * @generated from field: string erosion_control_contractor = 5;
   */
  erosionControlContractor?: string;

  /**
   * @generated from field: double cost = 6;
   */
  cost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double service_fee = 7;
   */
  serviceFee?: number | 'NaN' | 'Infinity' | '-Infinity';
};

export type ProjectJobPermitValid = ProjectJobPermit;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobPermit.
 * Use `create(ProjectJobPermitSchema)` to create a new message.
 */
export const ProjectJobPermitSchema: GenMessage<
  ProjectJobPermit,
  { jsonType: ProjectJobPermitJson; validType: ProjectJobPermitValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 0);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceGetResponse
 */
export type ProjectJobServiceGetResponse =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 4;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 5;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
     */
    job?: ProjectJobSettings;

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
     */
    uploads: { [key: string]: ProjectJobUpload };

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * Date in Y-m-d format
     *
     * @generated from field: google.protobuf.Timestamp due_date = 11;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 12;
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 13;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 15;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 17;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
     */
    flags?: ProjectJobFlags;

    /**
     * @generated from field: string job_type_uuid = 19;
     */
    jobTypeUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectJobServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceGetResponse
 */
export type ProjectJobServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
   */
  type?: ProjectJobTypeJson;

  /**
   * @generated from field: string project_uuid = 4;
   */
  projectUuid?: string;

  /**
   * @generated from field: double cost = 5;
   */
  cost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
   */
  job?: ProjectJobSettingsJson;

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
   */
  uploads?: { [key: string]: ProjectJobUploadJson };

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * Date in Y-m-d format
   *
   * @generated from field: google.protobuf.Timestamp due_date = 11;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: bool verification_email = 12;
   */
  verificationEmail?: boolean;

  /**
   * @generated from field: bool verified = 13;
   */
  verified?: boolean;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
   */
  contractType?: ProjectJobContractTypeJson;

  /**
   * @generated from field: string contract_type_custom = 15;
   */
  contractTypeCustom?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
   */
  status?: ProjectJobStatusJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 17;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
   */
  flags?: ProjectJobFlagsJson;

  /**
   * @generated from field: string job_type_uuid = 19;
   */
  jobTypeUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectJobServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceGetResponse
 */
export type ProjectJobServiceGetResponseValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 4;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 5;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
     */
    job?: ProjectJobSettingsValid;

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
     */
    uploads: { [key: string]: ProjectJobUploadValid };

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * Date in Y-m-d format
     *
     * @generated from field: google.protobuf.Timestamp due_date = 11;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 12;
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 13;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 15;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 17;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
     */
    flags?: ProjectJobFlagsValid;

    /**
     * @generated from field: string job_type_uuid = 19;
     */
    jobTypeUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectJobServiceDenormalizedValid;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdaterValid;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceGetResponse.
 * Use `create(ProjectJobServiceGetResponseSchema)` to create a new message.
 */
export const ProjectJobServiceGetResponseSchema: GenMessage<
  ProjectJobServiceGetResponse,
  {
    jsonType: ProjectJobServiceGetResponseJson;
    validType: ProjectJobServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 1);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceGetRequest
 */
export type ProjectJobServiceGetRequest =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceGetRequest
 */
export type ProjectJobServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceGetRequest
 */
export type ProjectJobServiceGetRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceGetRequest.
 * Use `create(ProjectJobServiceGetRequestSchema)` to create a new message.
 */
export const ProjectJobServiceGetRequestSchema: GenMessage<
  ProjectJobServiceGetRequest,
  {
    jsonType: ProjectJobServiceGetRequestJson;
    validType: ProjectJobServiceGetRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 2);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobUpload
 */
export type ProjectJobUpload =
  Message<'vmspdb.api.proto.v1.ProjectJobUpload'> & {
    /**
     * @generated from field: string name = 1;
     */
    name: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.UploadedFile files = 3;
     */
    files: UploadedFile[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobUpload
 */
export type ProjectJobUploadJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.UploadedFile files = 3;
   */
  files?: UploadedFileJson[];
};

export type ProjectJobUploadValid = ProjectJobUpload;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobUpload.
 * Use `create(ProjectJobUploadSchema)` to create a new message.
 */
export const ProjectJobUploadSchema: GenMessage<
  ProjectJobUpload,
  { jsonType: ProjectJobUploadJson; validType: ProjectJobUploadValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 3);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobClient
 */
export type ProjectJobClient =
  Message<'vmspdb.api.proto.v1.ProjectJobClient'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobClient
 */
export type ProjectJobClientJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;
};

export type ProjectJobClientValid = ProjectJobClient;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobClient.
 * Use `create(ProjectJobClientSchema)` to create a new message.
 */
export const ProjectJobClientSchema: GenMessage<
  ProjectJobClient,
  { jsonType: ProjectJobClientJson; validType: ProjectJobClientValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 4);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobManager
 */
export type ProjectJobManager =
  Message<'vmspdb.api.proto.v1.ProjectJobManager'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobManager
 */
export type ProjectJobManagerJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;
};

export type ProjectJobManagerValid = ProjectJobManager;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobManager.
 * Use `create(ProjectJobManagerSchema)` to create a new message.
 */
export const ProjectJobManagerSchema: GenMessage<
  ProjectJobManager,
  { jsonType: ProjectJobManagerJson; validType: ProjectJobManagerValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 5);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobFlags
 */
export type ProjectJobFlags = Message<'vmspdb.api.proto.v1.ProjectJobFlags'> & {
  /**
   * @generated from field: bool in_progress = 1;
   */
  inProgress: boolean;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobFlags
 */
export type ProjectJobFlagsJson = {
  /**
   * @generated from field: bool in_progress = 1;
   */
  inProgress?: boolean;
};

export type ProjectJobFlagsValid = ProjectJobFlags;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobFlags.
 * Use `create(ProjectJobFlagsSchema)` to create a new message.
 */
export const ProjectJobFlagsSchema: GenMessage<
  ProjectJobFlags,
  { jsonType: ProjectJobFlagsJson; validType: ProjectJobFlagsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 6);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobSettings
 */
export type ProjectJobSettings =
  Message<'vmspdb.api.proto.v1.ProjectJobSettings'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermit permits = 1;
     */
    permits: ProjectJobPermit[];

    /**
     * @generated from field: bool survey_notification = 10;
     */
    surveyNotification: boolean;

    /**
     * @generated from field: bool permit_service = 11;
     */
    permitService: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobSettings
 */
export type ProjectJobSettingsJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermit permits = 1;
   */
  permits?: ProjectJobPermitJson[];

  /**
   * @generated from field: bool survey_notification = 10;
   */
  surveyNotification?: boolean;

  /**
   * @generated from field: bool permit_service = 11;
   */
  permitService?: boolean;
};

export type ProjectJobSettingsValid = ProjectJobSettings;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobSettings.
 * Use `create(ProjectJobSettingsSchema)` to create a new message.
 */
export const ProjectJobSettingsSchema: GenMessage<
  ProjectJobSettings,
  { jsonType: ProjectJobSettingsJson; validType: ProjectJobSettingsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 7);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceCreateRequest
 */
export type ProjectJobServiceCreateRequest =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceCreateRequest'> & {
    /**
     *  string name = 1;
     *
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 3;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 4;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 5;
     */
    job?: ProjectJobSettings;

    /**
     * buf:lint:ignore FIELD_SAME_TYPE
     *
     * @generated from field: repeated string managers = 6;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 7;
     */
    uploads: { [key: string]: ProjectJobUpload };

    /**
     * @generated from field: map<string, string> attributes = 9;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 10;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 11 [deprecated = true];
     * @deprecated
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 12;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 13;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 14;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 15;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 16;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 17;
     */
    flags?: ProjectJobFlags;

    /**
     * @generated from field: string job_type_uuid = 18;
     */
    jobTypeUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceCreateRequest
 */
export type ProjectJobServiceCreateRequestJson = {
  /**
   *  string name = 1;
   *
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
   */
  type?: ProjectJobTypeJson;

  /**
   * @generated from field: string project_uuid = 3;
   */
  projectUuid?: string;

  /**
   * @generated from field: double cost = 4;
   */
  cost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 5;
   */
  job?: ProjectJobSettingsJson;

  /**
   * buf:lint:ignore FIELD_SAME_TYPE
   *
   * @generated from field: repeated string managers = 6;
   */
  managers?: string[];

  /**
   * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 7;
   */
  uploads?: { [key: string]: ProjectJobUploadJson };

  /**
   * @generated from field: map<string, string> attributes = 9;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 10;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: bool verification_email = 11 [deprecated = true];
   * @deprecated
   */
  verificationEmail?: boolean;

  /**
   * @generated from field: bool verified = 12;
   */
  verified?: boolean;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 13;
   */
  contractType?: ProjectJobContractTypeJson;

  /**
   * @generated from field: string contract_type_custom = 14;
   */
  contractTypeCustom?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 15;
   */
  status?: ProjectJobStatusJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 16;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 17;
   */
  flags?: ProjectJobFlagsJson;

  /**
   * @generated from field: string job_type_uuid = 18;
   */
  jobTypeUuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceCreateRequest
 */
export type ProjectJobServiceCreateRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceCreateRequest'> & {
    /**
     *  string name = 1;
     *
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 3;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 4;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 5;
     */
    job?: ProjectJobSettingsValid;

    /**
     * buf:lint:ignore FIELD_SAME_TYPE
     *
     * @generated from field: repeated string managers = 6;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 7;
     */
    uploads: { [key: string]: ProjectJobUploadValid };

    /**
     * @generated from field: map<string, string> attributes = 9;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 10;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 11 [deprecated = true];
     * @deprecated
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 12;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 13;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 14;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 15;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 16;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 17;
     */
    flags?: ProjectJobFlagsValid;

    /**
     * @generated from field: string job_type_uuid = 18;
     */
    jobTypeUuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceCreateRequest.
 * Use `create(ProjectJobServiceCreateRequestSchema)` to create a new message.
 */
export const ProjectJobServiceCreateRequestSchema: GenMessage<
  ProjectJobServiceCreateRequest,
  {
    jsonType: ProjectJobServiceCreateRequestJson;
    validType: ProjectJobServiceCreateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 8);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceDenormalized
 */
export type ProjectJobServiceDenormalized =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceDenormalized'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
     */
    project?: DenormalizedProject;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser managers = 2;
     */
    managers: DenormalizedUser[];

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedClient clients = 3;
     */
    clients: DenormalizedClient[];

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser project_managers = 4;
     */
    projectManagers: DenormalizedUser[];

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type = 5;
     */
    jobType?: DenormalizedJobType;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceDenormalized
 */
export type ProjectJobServiceDenormalizedJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
   */
  project?: DenormalizedProjectJson;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser managers = 2;
   */
  managers?: DenormalizedUserJson[];

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedClient clients = 3;
   */
  clients?: DenormalizedClientJson[];

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser project_managers = 4;
   */
  projectManagers?: DenormalizedUserJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type = 5;
   */
  jobType?: DenormalizedJobTypeJson;
};

export type ProjectJobServiceDenormalizedValid = ProjectJobServiceDenormalized;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceDenormalized.
 * Use `create(ProjectJobServiceDenormalizedSchema)` to create a new message.
 */
export const ProjectJobServiceDenormalizedSchema: GenMessage<
  ProjectJobServiceDenormalized,
  {
    jsonType: ProjectJobServiceDenormalizedJson;
    validType: ProjectJobServiceDenormalizedValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 9);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceCreateResponse
 */
export type ProjectJobServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 4;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 5;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
     */
    job?: ProjectJobSettings;

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
     */
    uploads: { [key: string]: ProjectJobUpload };

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * Date in Y-m-d format
     *
     * @generated from field: google.protobuf.Timestamp due_date = 11;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 12;
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 13;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 15;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 17;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
     */
    flags?: ProjectJobFlags;

    /**
     * @generated from field: string job_type_uuid = 19;
     */
    jobTypeUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectJobServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceCreateResponse
 */
export type ProjectJobServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
   */
  type?: ProjectJobTypeJson;

  /**
   * @generated from field: string project_uuid = 4;
   */
  projectUuid?: string;

  /**
   * @generated from field: double cost = 5;
   */
  cost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
   */
  job?: ProjectJobSettingsJson;

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
   */
  uploads?: { [key: string]: ProjectJobUploadJson };

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * Date in Y-m-d format
   *
   * @generated from field: google.protobuf.Timestamp due_date = 11;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: bool verification_email = 12;
   */
  verificationEmail?: boolean;

  /**
   * @generated from field: bool verified = 13;
   */
  verified?: boolean;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
   */
  contractType?: ProjectJobContractTypeJson;

  /**
   * @generated from field: string contract_type_custom = 15;
   */
  contractTypeCustom?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
   */
  status?: ProjectJobStatusJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 17;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
   */
  flags?: ProjectJobFlagsJson;

  /**
   * @generated from field: string job_type_uuid = 19;
   */
  jobTypeUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectJobServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceCreateResponse
 */
export type ProjectJobServiceCreateResponseValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 4;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 5;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
     */
    job?: ProjectJobSettingsValid;

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
     */
    uploads: { [key: string]: ProjectJobUploadValid };

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * Date in Y-m-d format
     *
     * @generated from field: google.protobuf.Timestamp due_date = 11;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 12;
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 13;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 15;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 17;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
     */
    flags?: ProjectJobFlagsValid;

    /**
     * @generated from field: string job_type_uuid = 19;
     */
    jobTypeUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectJobServiceDenormalizedValid;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdaterValid;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceCreateResponse.
 * Use `create(ProjectJobServiceCreateResponseSchema)` to create a new message.
 */
export const ProjectJobServiceCreateResponseSchema: GenMessage<
  ProjectJobServiceCreateResponse,
  {
    jsonType: ProjectJobServiceCreateResponseJson;
    validType: ProjectJobServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 10);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceListRequest
 */
export type ProjectJobServiceListRequest =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.JobSort sort = 10;
     */
    sort: JobSort;

    /**
     * @generated from field: repeated string employees = 6;
     */
    employees: string[];

    /**
     * @generated from field: repeated string managers = 13;
     */
    managers: string[];

    /**
     * @generated from field: string project = 7 [deprecated = true];
     * @deprecated
     */
    project: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobStatus status = 8;
     */
    status: ProjectJobStatus[];

    /**
     * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
     */
    dateRange?: DateRange;

    /**
     * @generated from field: optional string project_uuid = 11;
     */
    projectUuid?: string;

    /**
     * @generated from field: optional string project_job_uuid = 12;
     */
    projectJobUuid?: string;

    /**
     * @generated from field: optional bool only_manager = 14;
     */
    onlyManager?: boolean;

    /**
     * @generated from field: string nonce = 20;
     */
    nonce: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceListRequest
 */
export type ProjectJobServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.JobSort sort = 10;
   */
  sort?: JobSortJson;

  /**
   * @generated from field: repeated string employees = 6;
   */
  employees?: string[];

  /**
   * @generated from field: repeated string managers = 13;
   */
  managers?: string[];

  /**
   * @generated from field: string project = 7 [deprecated = true];
   * @deprecated
   */
  project?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobStatus status = 8;
   */
  status?: ProjectJobStatusJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
   */
  dateRange?: DateRangeJson;

  /**
   * @generated from field: optional string project_uuid = 11;
   */
  projectUuid?: string;

  /**
   * @generated from field: optional string project_job_uuid = 12;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: optional bool only_manager = 14;
   */
  onlyManager?: boolean;

  /**
   * @generated from field: string nonce = 20;
   */
  nonce?: string;
};

export type ProjectJobServiceListRequestValid = ProjectJobServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceListRequest.
 * Use `create(ProjectJobServiceListRequestSchema)` to create a new message.
 */
export const ProjectJobServiceListRequestSchema: GenMessage<
  ProjectJobServiceListRequest,
  {
    jsonType: ProjectJobServiceListRequestJson;
    validType: ProjectJobServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 11);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceHeading
 */
export type ProjectJobServiceHeading =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceHeading'> & {
    /**
     * @generated from field: string month = 1;
     */
    month: string;

    /**
     * @generated from field: double cost = 2;
     */
    cost: number;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceHeading
 */
export type ProjectJobServiceHeadingJson = {
  /**
   * @generated from field: string month = 1;
   */
  month?: string;

  /**
   * @generated from field: double cost = 2;
   */
  cost?: number | 'NaN' | 'Infinity' | '-Infinity';
};

export type ProjectJobServiceHeadingValid = ProjectJobServiceHeading;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceHeading.
 * Use `create(ProjectJobServiceHeadingSchema)` to create a new message.
 */
export const ProjectJobServiceHeadingSchema: GenMessage<
  ProjectJobServiceHeading,
  {
    jsonType: ProjectJobServiceHeadingJson;
    validType: ProjectJobServiceHeadingValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 12);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceRow
 */
export type ProjectJobServiceRow =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceRow'> & {
    /**
     * @generated from oneof vmspdb.api.proto.v1.ProjectJobServiceRow.type
     */
    type:
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceHeading heading = 1;
           */
          value: ProjectJobServiceHeading;
          case: 'heading';
        }
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceCreateResponse job = 2;
           */
          value: ProjectJobServiceCreateResponse;
          case: 'job';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceRow
 */
export type ProjectJobServiceRowJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceHeading heading = 1;
   */
  heading?: ProjectJobServiceHeadingJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceCreateResponse job = 2;
   */
  job?: ProjectJobServiceCreateResponseJson;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceRow
 */
export type ProjectJobServiceRowValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceRow'> & {
    /**
     * @generated from oneof vmspdb.api.proto.v1.ProjectJobServiceRow.type
     */
    type:
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceHeading heading = 1;
           */
          value: ProjectJobServiceHeadingValid;
          case: 'heading';
        }
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceCreateResponse job = 2;
           */
          value: ProjectJobServiceCreateResponseValid;
          case: 'job';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceRow.
 * Use `create(ProjectJobServiceRowSchema)` to create a new message.
 */
export const ProjectJobServiceRowSchema: GenMessage<
  ProjectJobServiceRow,
  { jsonType: ProjectJobServiceRowJson; validType: ProjectJobServiceRowValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 13);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceListResponse
 */
export type ProjectJobServiceListResponse =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobServiceCreateResponse items = 1;
     */
    items: ProjectJobServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceListResponse
 */
export type ProjectJobServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobServiceCreateResponse items = 1;
   */
  items?: ProjectJobServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceListResponse
 */
export type ProjectJobServiceListResponseValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobServiceCreateResponse items = 1;
     */
    items: ProjectJobServiceCreateResponseValid[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: PaginationValid;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceListResponse.
 * Use `create(ProjectJobServiceListResponseSchema)` to create a new message.
 */
export const ProjectJobServiceListResponseSchema: GenMessage<
  ProjectJobServiceListResponse,
  {
    jsonType: ProjectJobServiceListResponseJson;
    validType: ProjectJobServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 14);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceUpdateRequest
 */
export type ProjectJobServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
     */
    type: ProjectJobType;

    /**
     *  string project_uuid = 3 [
     *    (buf.validate.field).required = true,
     *    (buf.validate.field).string.uuid = true
     *  ];
     *
     * @generated from field: double cost = 4;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 5;
     */
    job?: ProjectJobSettings;

    /**
     * buf:lint:ignore FIELD_SAME_TYPE
     *
     * @generated from field: repeated string managers = 6;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 7;
     */
    uploads: { [key: string]: ProjectJobUpload };

    /**
     * @generated from field: map<string, string> attributes = 9;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 10;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 11 [deprecated = true];
     * @deprecated
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 12;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 13;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 14;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 15;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 16;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 17;
     */
    flags?: ProjectJobFlags;

    /**
     * @generated from field: string job_type_uuid = 18;
     */
    jobTypeUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceUpdateRequest
 */
export type ProjectJobServiceUpdateRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
   */
  type?: ProjectJobTypeJson;

  /**
   *  string project_uuid = 3 [
   *    (buf.validate.field).required = true,
   *    (buf.validate.field).string.uuid = true
   *  ];
   *
   * @generated from field: double cost = 4;
   */
  cost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 5;
   */
  job?: ProjectJobSettingsJson;

  /**
   * buf:lint:ignore FIELD_SAME_TYPE
   *
   * @generated from field: repeated string managers = 6;
   */
  managers?: string[];

  /**
   * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 7;
   */
  uploads?: { [key: string]: ProjectJobUploadJson };

  /**
   * @generated from field: map<string, string> attributes = 9;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 10;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: bool verification_email = 11 [deprecated = true];
   * @deprecated
   */
  verificationEmail?: boolean;

  /**
   * @generated from field: bool verified = 12;
   */
  verified?: boolean;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 13;
   */
  contractType?: ProjectJobContractTypeJson;

  /**
   * @generated from field: string contract_type_custom = 14;
   */
  contractTypeCustom?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 15;
   */
  status?: ProjectJobStatusJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 16;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 17;
   */
  flags?: ProjectJobFlagsJson;

  /**
   * @generated from field: string job_type_uuid = 18;
   */
  jobTypeUuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceUpdateRequest
 */
export type ProjectJobServiceUpdateRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
     */
    type: ProjectJobType;

    /**
     *  string project_uuid = 3 [
     *    (buf.validate.field).required = true,
     *    (buf.validate.field).string.uuid = true
     *  ];
     *
     * @generated from field: double cost = 4;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 5;
     */
    job?: ProjectJobSettingsValid;

    /**
     * buf:lint:ignore FIELD_SAME_TYPE
     *
     * @generated from field: repeated string managers = 6;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 7;
     */
    uploads: { [key: string]: ProjectJobUploadValid };

    /**
     * @generated from field: map<string, string> attributes = 9;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 10;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 11 [deprecated = true];
     * @deprecated
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 12;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 13;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 14;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 15;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 16;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 17;
     */
    flags?: ProjectJobFlagsValid;

    /**
     * @generated from field: string job_type_uuid = 18;
     */
    jobTypeUuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceUpdateRequest.
 * Use `create(ProjectJobServiceUpdateRequestSchema)` to create a new message.
 */
export const ProjectJobServiceUpdateRequestSchema: GenMessage<
  ProjectJobServiceUpdateRequest,
  {
    jsonType: ProjectJobServiceUpdateRequestJson;
    validType: ProjectJobServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 15);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceUpdateResponse
 */
export type ProjectJobServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 4;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 5;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
     */
    job?: ProjectJobSettings;

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
     */
    uploads: { [key: string]: ProjectJobUpload };

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * Date in Y-m-d format
     *
     * @generated from field: google.protobuf.Timestamp due_date = 11;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 12;
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 13;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 15;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 17;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
     */
    flags?: ProjectJobFlags;

    /**
     * @generated from field: string job_type_uuid = 19;
     */
    jobTypeUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectJobServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceUpdateResponse
 */
export type ProjectJobServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
   */
  type?: ProjectJobTypeJson;

  /**
   * @generated from field: string project_uuid = 4;
   */
  projectUuid?: string;

  /**
   * @generated from field: double cost = 5;
   */
  cost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
   */
  job?: ProjectJobSettingsJson;

  /**
   * @generated from field: repeated string managers = 7;
   */
  managers?: string[];

  /**
   * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
   */
  uploads?: { [key: string]: ProjectJobUploadJson };

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * Date in Y-m-d format
   *
   * @generated from field: google.protobuf.Timestamp due_date = 11;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: bool verification_email = 12;
   */
  verificationEmail?: boolean;

  /**
   * @generated from field: bool verified = 13;
   */
  verified?: boolean;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
   */
  contractType?: ProjectJobContractTypeJson;

  /**
   * @generated from field: string contract_type_custom = 15;
   */
  contractTypeCustom?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
   */
  status?: ProjectJobStatusJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 17;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
   */
  flags?: ProjectJobFlagsJson;

  /**
   * @generated from field: string job_type_uuid = 19;
   */
  jobTypeUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectJobServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceUpdateResponse
 */
export type ProjectJobServiceUpdateResponseValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3;
     */
    type: ProjectJobType;

    /**
     * @generated from field: string project_uuid = 4;
     */
    projectUuid: string;

    /**
     * @generated from field: double cost = 5;
     */
    cost: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobSettings job = 6;
     */
    job?: ProjectJobSettingsValid;

    /**
     * @generated from field: repeated string managers = 7;
     */
    managers: string[];

    /**
     * @generated from field: map<string, vmspdb.api.proto.v1.ProjectJobUpload> uploads = 8;
     */
    uploads: { [key: string]: ProjectJobUploadValid };

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * Date in Y-m-d format
     *
     * @generated from field: google.protobuf.Timestamp due_date = 11;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: bool verification_email = 12;
     */
    verificationEmail: boolean;

    /**
     * @generated from field: bool verified = 13;
     */
    verified: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobContractType contract_type = 14;
     */
    contractType: ProjectJobContractType;

    /**
     * @generated from field: string contract_type_custom = 15;
     */
    contractTypeCustom: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobStatus status = 16;
     */
    status: ProjectJobStatus;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 17;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobFlags flags = 18;
     */
    flags?: ProjectJobFlagsValid;

    /**
     * @generated from field: string job_type_uuid = 19;
     */
    jobTypeUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectJobServiceDenormalizedValid;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdaterValid;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceUpdateResponse.
 * Use `create(ProjectJobServiceUpdateResponseSchema)` to create a new message.
 */
export const ProjectJobServiceUpdateResponseSchema: GenMessage<
  ProjectJobServiceUpdateResponse,
  {
    jsonType: ProjectJobServiceUpdateResponseJson;
    validType: ProjectJobServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 16);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceDeleteRequest
 */
export type ProjectJobServiceDeleteRequest =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceDeleteRequest
 */
export type ProjectJobServiceDeleteRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceDeleteRequest
 */
export type ProjectJobServiceDeleteRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceDeleteRequest.
 * Use `create(ProjectJobServiceDeleteRequestSchema)` to create a new message.
 */
export const ProjectJobServiceDeleteRequestSchema: GenMessage<
  ProjectJobServiceDeleteRequest,
  {
    jsonType: ProjectJobServiceDeleteRequestJson;
    validType: ProjectJobServiceDeleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 17);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceDeleteResponse
 */
export type ProjectJobServiceDeleteResponse =
  Message<'vmspdb.api.proto.v1.ProjectJobServiceDeleteResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobServiceDeleteResponse
 */
export type ProjectJobServiceDeleteResponseJson = {};

export type ProjectJobServiceDeleteResponseValid =
  ProjectJobServiceDeleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobServiceDeleteResponse.
 * Use `create(ProjectJobServiceDeleteResponseSchema)` to create a new message.
 */
export const ProjectJobServiceDeleteResponseSchema: GenMessage<
  ProjectJobServiceDeleteResponse,
  {
    jsonType: ProjectJobServiceDeleteResponseJson;
    validType: ProjectJobServiceDeleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_jobs, 18);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobContractType
 */
export enum ProjectJobContractType {
  /**
   * @generated from enum value: PROJECT_JOB_CONTRACT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_JOB_CONTRACT_TYPE_PAY_ON_PICKUP = 1;
   */
  PAY_ON_PICKUP = 1,

  /**
   * @generated from enum value: PROJECT_JOB_CONTRACT_TYPE_NET_30 = 2;
   */
  NET_30 = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobContractType
 */
export type ProjectJobContractTypeJson =
  | 'PROJECT_JOB_CONTRACT_TYPE_UNSPECIFIED'
  | 'PROJECT_JOB_CONTRACT_TYPE_PAY_ON_PICKUP'
  | 'PROJECT_JOB_CONTRACT_TYPE_NET_30';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectJobContractType.
 */
export const ProjectJobContractTypeSchema: GenEnum<
  ProjectJobContractType,
  ProjectJobContractTypeJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_project_jobs, 0);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobPermitType
 */
export enum ProjectJobPermitType {
  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_TYPE_BUILDING = 1;
   */
  BUILDING = 1,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_TYPE_SITE_WORK = 2;
   */
  SITE_WORK = 2,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_TYPE_ENCROACHMENT = 3;
   */
  ENCROACHMENT = 3,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_TYPE_POOL = 4;
   */
  POOL = 4,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_TYPE_FENCE = 5;
   */
  FENCE = 5,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobPermitType
 */
export type ProjectJobPermitTypeJson =
  | 'PROJECT_JOB_PERMIT_TYPE_UNSPECIFIED'
  | 'PROJECT_JOB_PERMIT_TYPE_BUILDING'
  | 'PROJECT_JOB_PERMIT_TYPE_SITE_WORK'
  | 'PROJECT_JOB_PERMIT_TYPE_ENCROACHMENT'
  | 'PROJECT_JOB_PERMIT_TYPE_POOL'
  | 'PROJECT_JOB_PERMIT_TYPE_FENCE';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectJobPermitType.
 */
export const ProjectJobPermitTypeSchema: GenEnum<
  ProjectJobPermitType,
  ProjectJobPermitTypeJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_project_jobs, 1);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobStatus
 */
export enum ProjectJobStatus {
  /**
   * @generated from enum value: PROJECT_JOB_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_JOB_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: PROJECT_JOB_STATUS_BILLING_REQUESTED = 2;
   */
  BILLING_REQUESTED = 2,

  /**
   * @generated from enum value: PROJECT_JOB_STATUS_BILLED = 3;
   */
  BILLED = 3,

  /**
   * @generated from enum value: PROJECT_JOB_STATUS_ARCHIVED = 4;
   */
  ARCHIVED = 4,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobStatus
 */
export type ProjectJobStatusJson =
  | 'PROJECT_JOB_STATUS_UNSPECIFIED'
  | 'PROJECT_JOB_STATUS_ACTIVE'
  | 'PROJECT_JOB_STATUS_BILLING_REQUESTED'
  | 'PROJECT_JOB_STATUS_BILLED'
  | 'PROJECT_JOB_STATUS_ARCHIVED';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectJobStatus.
 */
export const ProjectJobStatusSchema: GenEnum<
  ProjectJobStatus,
  ProjectJobStatusJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_project_jobs, 2);

/**
 * @generated from enum vmspdb.api.proto.v1.JobSort
 */
export enum JobSort {
  /**
   * @generated from enum value: JOB_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_SORT_JOB_NUMBER = 1;
   */
  JOB_NUMBER = 1,

  /**
   * @generated from enum value: JOB_SORT_PROJECT_NAME = 2;
   */
  PROJECT_NAME = 2,

  /**
   * @generated from enum value: JOB_SORT_CLIENT_NAME = 3;
   */
  CLIENT_NAME = 3,

  /**
   * @generated from enum value: JOB_SORT_JOB_MANAGER_NAME = 4;
   */
  JOB_MANAGER_NAME = 4,

  /**
   * @generated from enum value: JOB_SORT_TYPE = 5;
   */
  TYPE = 5,

  /**
   * @generated from enum value: JOB_SORT_COST = 6;
   */
  COST = 6,

  /**
   * @generated from enum value: JOB_SORT_NOTES = 7;
   */
  NOTES = 7,

  /**
   * @generated from enum value: JOB_SORT_START_WORK_DATE = 8;
   */
  START_WORK_DATE = 8,

  /**
   * @generated from enum value: JOB_SORT_DUE_DATE = 9;
   */
  DUE_DATE = 9,

  /**
   * @generated from enum value: JOB_SORT_STATUS = 10;
   */
  STATUS = 10,
}

/**
 * @generated from enum vmspdb.api.proto.v1.JobSort
 */
export type JobSortJson =
  | 'JOB_SORT_UNSPECIFIED'
  | 'JOB_SORT_JOB_NUMBER'
  | 'JOB_SORT_PROJECT_NAME'
  | 'JOB_SORT_CLIENT_NAME'
  | 'JOB_SORT_JOB_MANAGER_NAME'
  | 'JOB_SORT_TYPE'
  | 'JOB_SORT_COST'
  | 'JOB_SORT_NOTES'
  | 'JOB_SORT_START_WORK_DATE'
  | 'JOB_SORT_DUE_DATE'
  | 'JOB_SORT_STATUS';

/**
 * Describes the enum vmspdb.api.proto.v1.JobSort.
 */
export const JobSortSchema: GenEnum<JobSort, JobSortJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_project_jobs, 3);

/**
 * @generated from service vmspdb.api.proto.v1.ProjectJobService
 */
export const ProjectJobService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectJobService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof ProjectJobServiceGetRequestSchema;
    output: typeof ProjectJobServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectJobService.Create
   */
  create: {
    methodKind: 'unary';
    input: typeof ProjectJobServiceCreateRequestSchema;
    output: typeof ProjectJobServiceCreateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectJobService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof ProjectJobServiceUpdateRequestSchema;
    output: typeof ProjectJobServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectJobService.Delete
   */
  delete: {
    methodKind: 'unary';
    input: typeof ProjectJobServiceDeleteRequestSchema;
    output: typeof ProjectJobServiceDeleteResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectJobService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof ProjectJobServiceListRequestSchema;
    output: typeof ProjectJobServiceListResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_project_jobs, 0);
